import * as React from 'react';
import { toast } from 'react-toastify';
import type { ItemPart, PartCompleteJob } from './models/DriverJobInterfaces';
import { useState } from 'react';

interface DriverJobsSiteDeparturePartItemsProps {
    partCompleteJob: PartCompleteJob;
    back(): void;
    updateNotes(updatedNotes: string): void;
    updateItemNumber(itemIndex: number, fieldName: string, fieldValue: number): void;
    updateItemBool(itemIndex: number, fieldName: string, fieldValue: boolean): void;
    updateItemPart(itemIndex: number, partIndex: number, itemPart: ItemPart): void;
    next(): void;
}

const DriverJobsSiteDeparturePartItemsData = (props: DriverJobsSiteDeparturePartItemsProps) => {
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [showValidation, setShowValidation] = useState(false);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const back = (e: any) => {
        e.preventDefault();

        props.back();
    }

    const clearError = (errorItem: string) => {
        let errorList = errors;
        delete errorList[errorItem];

        setErrors(errorList);
    }

    const handleNoteChange = (e: any) => {
        clearError(e.target.name);
        props.updateNotes(e.target.value);
    }

    const handlePercentCompleteNumber = (e: any, itemIndex: number) => {
        clearError(e.target.name);
        props.updateItemNumber(itemIndex, "percentComplete", e.target.value * 1);
    }

    const handleIsCompleteChange = (e: any, itemIndex: number) => {
        clearError(e.target.name);
        props.updateItemBool(itemIndex, "isComplete", e.target.checked);
    }

    const handleOtherCheckboxChange = (e: any, itemIndex: number) => {
        clearError(e.target.name);
        props.updateItemBool(itemIndex, "other", e.target.checked);
    }

    const handleCellCheckboxChange = (e: any, itemIndex: number, partIndex: number) => {
        clearError(e.target.name);
        var partCompleteJob = props.partCompleteJob;
        var jobs = partCompleteJob.jobItems;
        var item = jobs[itemIndex];
        var itemParts = [...item.itemParts];
        var part = itemParts[partIndex];
        part.isComplete = e.target.checked;
        props.updateItemPart(itemIndex, partIndex, part);

        var itemsChecked = item.itemParts.filter(i => i.isComplete);
        if (e.target.checked || itemsChecked.length > 0) {
            props.updateItemBool(itemIndex, "other", false);
            props.updateItemBool(itemIndex, "otherDisabled", true);
        } else if (itemsChecked.length === 0) {
            props.updateItemBool(itemIndex, "otherDisabled", false);
        }
    }

    const validate = () => {
        let jobItems = props.partCompleteJob.jobItems;
        let errorList: any = {};
        let formIsValid = true;

        for (var i = 0; i < jobItems.length; i++) {
            var jobItem = jobItems[i];
            if (jobItem.itemId === 4 && jobItem.percentComplete < 0) {
                formIsValid = false;
            }
        }

        let otherSelected = jobItems.filter(i => i.other).length > 0;
        if (otherSelected && !props.partCompleteJob.notes) {
            formIsValid = false;
            errorList["notes"] = "Notes are required when ticking Other";
            setErrors(errorList);
        }

        setShowValidation(true);
        return formIsValid;
    }

    const next = (e: any) => {
        e.preventDefault();
        if (validate()) {
            props.next();
        } else {
            toast.error("Please fix validation errors!");
        }
    }

    
    var isKsItems = props.partCompleteJob.jobItems.filter(p => p.itemId === 4).length > 0;

    return (
        <div>
            <div className="mobileFont marginTop10 marginBottom10">
                <div className="makeitflexspacebetween marginBottom10">
                    <h2 className="mobile-margin">Job Partially Complete</h2>
                    <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => back(e)}></i>
                </div>

                <div>Tick <span className="makeitred makeitbold">ONLY</span> items that have been <span className="makeitred makeitbold">FULLY</span> complete</div>
                <div className={isKsItems ? "" : "hidden"}><span className="makeitred makeitbold">Kwikstage Items</span> - Select % Complete</div>
                <table className="table__full marginBottom10">
                    <tbody>
                        {props.partCompleteJob.jobItems.map((item, index) =>
                            <React.Fragment key={index}>
                                <tr>
                                    <td>
                                        {item.unitNumberDisplay === "" ? "" : item.unitNumberDisplay + " - "}
                                        {item.type}
                                    </td>
                                    <td className="makeitbold">
                                        {item.item}
                                    </td>
                                    <td>
                                        {item.itemQuantityType}
                                    </td>
                                    <td className={item.itemParts.length === 0 ? "driverjobs-part--checkcenter" : "hidden"}>
                                        <input type='checkbox' id="isComplete" name="isComplete" className={item.itemId === 4 ? "hidden" : 'checkbox driverjobs-part--check'} checked={item.isComplete} onChange={(e) => handleIsCompleteChange(e, index)}></input>
                                        <select className={item.itemId === 4 ? "select" : "hidden"} id="percentComplete" name="percentComplete" value={item.percentComplete} onChange={(e) => handlePercentCompleteNumber(e, index)}>
                                            <option value={-1}></option>
                                            <option value={0}>0</option>
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={30}>30</option>
                                            <option value={40}>40</option>
                                            <option value={50}>50</option>
                                            <option value={60}>60</option>
                                            <option value={70}>70</option>
                                            <option value={80}>80</option>
                                            <option value={90}>90</option>
                                            <option value={100}>100</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr className={showValidation && item.itemId === 4 && item.percentComplete < 0 ? "" : "hidden"}>
                                    <td colSpan={4}>
                                        <span className="makeitred">Select the % complete for Kwikstage Item</span>
                                    </td>
                                </tr>
                                <tr className={item.itemParts.length === 0 ? "hidden" : ""}>
                                    <td colSpan={3}>
                                        <table className="makeitflexcenter">
                                            <tbody>
                                                {item.itemParts.map((part, partIndex) =>
                                                    <tr key={part.itemPartId}>
                                                        <td className="driverjobs-part--width">
                                                            {part.part}
                                                        </td>
                                                        <td className="driverjobs-part--checkcenter">
                                                            <input type='checkbox' id="isComplete" name="isComplete" className='checkbox driverjobs-part--check' checked={part.isComplete} onChange={(e) => handleCellCheckboxChange(e, index, partIndex)}></input>
                                                        </td>
                                                    </tr>
                                                )}
                                                <tr>
                                                    <td className="driverjobs-part--width">
                                                        Other
                                                    </td>
                                                    <td className="driverjobs-part--checkcenter">
                                                        <input type='checkbox' id="isComplete" name="isComplete" className='checkbox driverjobs-part--check' checked={item.other} onChange={(e) => handleOtherCheckboxChange(e, index)} disabled={item.otherDisabled}></input>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>

                                </tr>
                                <tr className={item.itemParts.length === 0 ? "hidden" : ""}>
                                    <td colSpan={3}>
                                        <span>NOTE: Tick Other if job has started but no items have been fully completed.</span>
                                        <hr></hr>
                                    </td>
                                </tr>
                            </React.Fragment>
                        )}
                    </tbody>
                </table>
                <div>
                    <label className="input-group" htmlFor="notes">
                        <span className="label-mobile">Additional Notes</span>
                        <textarea className="input marginLeft0 job__noteSize label-mobile" maxLength={500} id="notes" name="notes" value={props.partCompleteJob.notes} onChange={(e) => handleNoteChange(e)}></textarea>
                    </label>
                    <span className="label errors">{errors["notes"]}</span>
                </div>
                <div className="defaultbutton__container--right marginTop10">
                    <i className="mobile-icon-green fas fa-arrow-alt-circle-right mobileMenuSize" onClick={(e) => next(e)}></i>
                </div>
            </div>
        </div>
    );
}

export default DriverJobsSiteDeparturePartItemsData;